/**
 * @generated SignedSource<<69733c56eb29fd3a00d4eb117e6630ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductMirrorTypes = "COLORED" | "MIRRORED" | "NONE";
export type ModelUpdateOrCreateInput = {
  attributeGroups?: NullableValueInputOfListOfAttributeGroupInput | null;
  attributeSteps?: NullableValueInputOfListOfAttributeStepInput | null;
  attributes?: NullableValueInputOfListOfAttributeInput | null;
  cameraSideMappings?: NullableValueInputOfListOfCameraSideMappingInput | null;
  code?: ValueInputOfStringInput | null;
  colors?: NullableValueInputOfListOfModelColorCreateInput | null;
  environment?: ValueInputOfInt32Input | null;
  id?: string | null;
  largeImageUrl?: ValueInputOfStringInput | null;
  name?: ValueInputOfStringInput | null;
  options?: NullableValueInputOfListOfModelOptionInput | null;
  preview3D?: NullableValueInputOfPreview3DInput | null;
  pricingModelID?: ValueInputOfInt32Input | null;
  providerCode?: ValueInputOfStringInput | null;
  salesChannelID?: NullableValueInputOfStringInput | null;
  sceneConfig?: NullableValueInputOfModelSceneConfigInput | null;
  scenes?: NullableValueInputOfListOfModelSceneInput | null;
  smallImageUrl?: ValueInputOfStringInput | null;
  statusID?: ValueInputOfInt32Input | null;
};
export type ValueInputOfInt32Input = {
  value: number;
};
export type ValueInputOfStringInput = {
  value?: string | null;
};
export type NullableValueInputOfListOfModelColorCreateInput = {
  value?: ReadonlyArray<ModelColorCreateInput | null> | null;
};
export type ModelColorCreateInput = {
  code: string;
  colorGuid: any;
  colorId?: number | null;
  colorProviderCode?: string | null;
  name?: string | null;
  position: number;
  sides?: ReadonlyArray<ModelSideCreateInput | null> | null;
};
export type ModelSideCreateInput = {
  areas: ReadonlyArray<ModelAreaCreateInput>;
  cameraLocationID?: any | null;
  canRotate: boolean;
  code: string;
  imageUrl: string;
  mandatory: boolean;
  name: string;
  ppcm: number;
  sideGuid: any;
  sideId?: number | null;
  sortOrder: number;
  tempImageFileKey: string;
};
export type ModelAreaCreateInput = {
  areaId?: number | null;
  boundsHeight: number;
  boundsWidth: number;
  boundsX: number;
  boundsY: number;
  clipOut: boolean;
  guid: string;
  layers: ReadonlyArray<ModelAreaLayerCreateInput>;
  name: string;
  path: string;
  pathSVG: string;
  templateFile?: ModelAreaTemplateFileCreateInput | null;
};
export type ModelAreaLayerCreateInput = {
  description: string;
  displayName: string;
  displayOrder: number;
  id?: string | null;
  isClipMask: boolean;
  isOutputClipped: boolean;
  isVisibleInCanvas: boolean;
  isVisibleInCart: boolean;
  isVisibleInOutput: boolean;
  json: string;
  name: string;
  showIn3DPreview: boolean;
  showLabel: boolean;
  svg: string;
};
export type ModelAreaTemplateFileCreateInput = {
  documentHeight: number;
  documentWidth: number;
  fileID?: string | null;
  fileObjectID?: number | null;
};
export type NullableValueInputOfListOfModelOptionInput = {
  value?: ReadonlyArray<ModelOptionInput | null> | null;
};
export type ModelOptionInput = {
  colorGuid: any;
  optionId?: number | null;
  optionsData: ModelOptionsDataInput;
  sideGuid?: any | null;
};
export type ModelOptionsDataInput = {
  backgroundColor?: string | null;
  backgroundImageFileObjectID?: number | null;
  backgroundImageTempUrl?: string | null;
  backgroundImageThumbnailFileObjectID?: number | null;
  backgroundImageThumbnailUrl?: string | null;
  backgroundImageUrl?: string | null;
  backgroundPresetID?: number | null;
  backgroundType?: number | null;
  depth?: number | null;
  edgesColor?: string | null;
  includeBorderInPrintFiles: boolean;
  is3DAutoGenEnabled: boolean;
  isResizable: boolean;
  isSplitOutput: boolean;
  keepAspectRatio: boolean;
  lockHeight: boolean;
  lockWidth: boolean;
  maxArea?: number | null;
  maxHeight?: number | null;
  maxSizeForSide?: number | null;
  maxWidth?: number | null;
  minArea?: number | null;
  minHeight?: number | null;
  minSplitHeight?: number | null;
  minSplitWidth?: number | null;
  minWidth?: number | null;
  mirrorType: ProductMirrorTypes;
  presets: ReadonlyArray<ModelOptionDataPresetDataInput>;
  shape: number;
  showHeightSize: boolean;
  showSplitGrid: boolean;
  showWidthSize: boolean;
  startHeight?: number | null;
  startSplitColumns?: number | null;
  startSplitRows?: number | null;
  startWidth?: number | null;
  stepHeight?: number | null;
  stepWidth?: number | null;
};
export type ModelOptionDataPresetDataInput = {
  height: number;
  name?: string | null;
  width: number;
};
export type NullableValueInputOfListOfModelSceneInput = {
  value?: ReadonlyArray<ModelSceneInput | null> | null;
};
export type ModelSceneInput = {
  isDefault: boolean;
  meshDesignEffects: ReadonlyArray<ModelSceneMeshDesignEffectInput>;
  meshSides: ReadonlyArray<ModelSceneMeshSideInput>;
  sceneId?: any | null;
};
export type ModelSceneMeshSideInput = {
  colorID?: number | null;
  config?: MeshDesignConfigInput | null;
  isNormalmapEnabled: boolean;
  key?: string | null;
  materialID?: any | null;
  materialTexture?: string | null;
  matrix?: string | null;
  meshID: any;
  percHeight: number;
  percWidth: number;
  sideID: number;
  subMeshID: number;
  transform?: TransformInput | null;
  uvChannel: number;
};
export type TransformInput = {
  positionX: number;
  positionY: number;
  rotation: number;
  scalingX: number;
  scalingY: number;
};
export type MeshDesignConfigInput = {
  diffuse?: DiffuseConfigInput | null;
  general?: MeshDesignGeneralConfigInput | null;
  innerShadow?: InnerShadowConfigInput | null;
  normalmap?: NormalmapConfigInput | null;
  opacity?: OpacityConfigInput | null;
  outerShadow?: OuterShadowConfigInput | null;
};
export type MeshDesignGeneralConfigInput = {
  desktopTextureResolutionHeight?: number | null;
  desktopTextureResolutionWidth?: number | null;
  mobileTextureResolutionHeight?: number | null;
  mobileTextureResolutionWidth?: number | null;
  showDesign: boolean;
};
export type DiffuseConfigInput = {
  blendMode?: string | null;
  enabled: boolean;
  level: number;
};
export type OpacityConfigInput = {
  enabled: boolean;
};
export type NormalmapConfigInput = {
  bevel: boolean;
  bias: number;
  enabled: boolean;
  intensity: number;
  invertG: boolean;
  invertR: boolean;
  postBlur: number;
  postBlurEnabled: boolean;
  preBlur: number;
  preBlurEnabled: boolean;
  showDesign: boolean;
  showOnDesign: boolean;
  showOnMesh: boolean;
};
export type OuterShadowConfigInput = {
  angle: number;
  color?: string | null;
  distance: number;
  enabled: boolean;
  size: number;
};
export type InnerShadowConfigInput = {
  angle: number;
  color?: string | null;
  distance: number;
  enabled: boolean;
  size: number;
};
export type ModelSceneMeshDesignEffectInput = {
  config?: MeshDesignConfigInput | null;
  effectID?: number | null;
  isDefault: boolean;
  materialID?: any | null;
  meshID: any;
  name?: string | null;
  subMeshID: number;
};
export type NullableValueInputOfListOfAttributeInput = {
  value?: ReadonlyArray<AttributeInput | null> | null;
};
export type AttributeInput = {
  attributeCode?: string | null;
  attributeGuid: any;
  attributeId?: number | null;
  attributeTypeID: number;
  constraintExpression?: AttributeExpressionInput | null;
  defaultValue?: string | null;
  description?: string | null;
  displayOrder: number;
  groupGuid: any;
  groupID: number;
  hideOptionsLabel: boolean;
  meshSelector?: string | null;
  name?: string | null;
  optionPreviewShapeID: number;
  options: ReadonlyArray<AttributeOptionInput>;
  postActions: ReadonlyArray<AttributeSceneActionInput>;
  preActions: ReadonlyArray<AttributeSceneActionInput>;
  pricings: ReadonlyArray<AttributePricingInput>;
  sceneCameraLocationID?: any | null;
  stepGuid: any;
  stepID: number;
  valueActions: ReadonlyArray<AttributeSceneActionInput>;
};
export type AttributeOptionInput = {
  actions: ReadonlyArray<AttributeSceneActionInput>;
  constraintExpression?: AttributePropositionInput | null;
  description?: string | null;
  displayOrder: number;
  extensionFields: ReadonlyArray<AttributeOptionExtensionFieldInput>;
  imageFileObjectID: number;
  imageUrl?: string | null;
  isDefault: boolean;
  name?: string | null;
  optionCode?: string | null;
  optionGuid: any;
  optionId?: number | null;
  tempImageFileKey?: string | null;
  tempImageFileObjectID: number;
};
export type AttributePropositionInput = {
  attributeGuid?: any | null;
  op?: string | null;
  value?: string | null;
};
export type AttributeSceneActionInput = {
  actionGuid: any;
  actionId?: number | null;
  actionTypeID: number;
  deviceTypes: number;
  execOrder: number;
  name?: string | null;
  propertyName?: string | null;
  sceneElementTypeID: number;
  selector?: string | null;
  value?: string | null;
};
export type AttributeOptionExtensionFieldInput = {
  dataTypeID: number;
  extensionFieldID?: number | null;
  formatString?: string | null;
  label?: string | null;
  name?: string | null;
  operationTypeID: number;
  value?: string | null;
};
export type AttributePricingInput = {
  attributePricingID?: number | null;
  constraintExpression?: AttributeExpressionInput | null;
  price: number;
  pricingID: number;
  selectedOptionGuid?: any | null;
  selectedOptionID?: number | null;
  selectedValue?: string | null;
};
export type AttributeExpressionInput = {
  expressions: ReadonlyArray<AttributeExpressionInput>;
  op?: string | null;
  propositions: ReadonlyArray<AttributePropositionInput>;
};
export type NullableValueInputOfListOfAttributeGroupInput = {
  value?: ReadonlyArray<AttributeGroupInput | null> | null;
};
export type AttributeGroupInput = {
  attributesAlwaysOpened: boolean;
  direction: number;
  displayOrder: number;
  groupGuid: any;
  groupID: number;
  imageUrl?: string | null;
  meshSelector?: string | null;
  name?: string | null;
  sceneCameraLocationID?: any | null;
  tempImageFileKey?: string | null;
  tempImageUrl?: string | null;
};
export type NullableValueInputOfListOfAttributeStepInput = {
  value?: ReadonlyArray<AttributeStepInput | null> | null;
};
export type AttributeStepInput = {
  cameraLocationID?: any | null;
  displayOrder: number;
  groupGuid: any;
  groupID: number;
  name?: string | null;
  stepGuid: any;
  stepID: number;
};
export type NullableValueInputOfPreview3DInput = {
  value?: Preview3DInput | null;
};
export type Preview3DInput = {
  variantsAttributeOptions?: VariantsAttributeOptionsInput | null;
};
export type VariantsAttributeOptionsInput = {
  attributeGuid: any;
  variableMaterials?: ReadonlyArray<VariableMaterialInput | null> | null;
  variantOptions?: ReadonlyArray<VariantOptionInput | null> | null;
};
export type VariableMaterialInput = {
  materialID?: string | null;
  meshes?: ReadonlyArray<string | null> | null;
};
export type VariantOptionInput = {
  materials?: ReadonlyArray<VariantOptionMaterialInput | null> | null;
  meshes?: ReadonlyArray<string | null> | null;
  optionGuid: any;
  variantID?: string | null;
};
export type VariantOptionMaterialInput = {
  actions?: ReadonlyArray<VariantOptionMaterialActionInput | null> | null;
  optionMaterialID?: string | null;
  variableMaterialID?: string | null;
};
export type VariantOptionMaterialActionInput = {
  actionGuid: any;
  meshID?: string | null;
};
export type NullableValueInputOfModelSceneConfigInput = {
  value?: ModelSceneConfigInput | null;
};
export type ModelSceneConfigInput = {
  general?: ModelSceneGeneralConfigInput | null;
};
export type ModelSceneGeneralConfigInput = {
  arAnchor?: string | null;
  arEnabled?: boolean | null;
};
export type NullableValueInputOfStringInput = {
  value?: string | null;
};
export type NullableValueInputOfListOfCameraSideMappingInput = {
  value?: ReadonlyArray<CameraSideMappingInput | null> | null;
};
export type CameraSideMappingInput = {
  cameraLocationID?: any | null;
  colorID: number;
  sideID: number;
};
export type useSaveProductUpdateProductMutation$variables = {
  compressedInput?: string | null;
  input?: ModelUpdateOrCreateInput | null;
};
export type useSaveProductUpdateProductMutation$data = {
  readonly createOrUpdateModelV2: {
    readonly model: {
      readonly id: string;
      readonly salesChannelID: string;
    } | null;
  };
};
export type useSaveProductUpdateProductMutation = {
  response: useSaveProductUpdateProductMutation$data;
  variables: useSaveProductUpdateProductMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "compressedInput"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "compressedInput",
        "variableName": "compressedInput"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ModelUpdateOrCreateOutput",
    "kind": "LinkedField",
    "name": "createOrUpdateModelV2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "salesChannelID",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useSaveProductUpdateProductMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useSaveProductUpdateProductMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f725179430558f6dce808ae73c9a6a71",
    "id": null,
    "metadata": {},
    "name": "useSaveProductUpdateProductMutation",
    "operationKind": "mutation",
    "text": "mutation useSaveProductUpdateProductMutation(\n  $input: ModelUpdateOrCreateInput\n  $compressedInput: String\n) {\n  createOrUpdateModelV2(input: $input, compressedInput: $compressedInput) {\n    model {\n      id\n      salesChannelID\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9dfeb310e2b035606444c10620dbb95c";

export default node;
